import { Box, IconButton, Stack } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsIcon from "@mui/icons-material/Settings";
import { useLocation, useNavigate } from "react-router-dom";

import { useAuth } from "../../../app/providers/AuthProvider";

export default function ConsultantSidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();
  const isHome = location.pathname === "/consultora" || location.pathname === "/consultora/";
  const isSettings = location.pathname.startsWith("/consultora/insumos-globales");

  const buttonSx = (active) => ({
    width: 38,
    height: 38,
    bgcolor: active ? "common.white" : "primary.400",
    border: active ? "1px solid rgba(15,23,42,.08)" : "1px solid transparent",
    boxShadow: active ? "0 8px 18px rgba(2,8,23,.12)" : "none",
    "&:hover": { bgcolor: active ? "neutral.50" : "primary.500" },
  });

  const iconSx = (active) => ({
    width: 30,
    height: 30,
    color: active ? "primary.500" : "neutral.50",
  });

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <Box sx={{ width: { xs: 70, md: 90 }, p: 2, display: "flex", justifyContent: "center" }}>
      <Stack sx={{ width: "100%", minHeight: "calc(88dvh - 32px)", justifyContent: "space-between" }}>
        <Stack spacing={2.5} sx={{ alignItems: "center", py: 2.5, bgcolor: "neutral.150", borderRadius: "103.5px", boxShadow: "inset 0 0 4px rgba(117,117,138,.5)" }}>
          <IconButton aria-label="Inicio de Consultora" onClick={() => navigate("/consultora")} sx={buttonSx(isHome)}>
            <HomeIcon sx={iconSx(isHome)} />
          </IconButton>
          <IconButton aria-label="Configuraciones generales" onClick={() => navigate("/consultora/insumos-globales")} sx={buttonSx(isSettings)}>
            <SettingsIcon sx={iconSx(isSettings)} />
          </IconButton>
        </Stack>

        <Stack sx={{ alignItems: "center", py: 2.5, bgcolor: "neutral.150", borderRadius: "103.5px", boxShadow: "inset 0 0 4px rgba(117,117,138,.5)" }}>
          <IconButton aria-label="Cerrar sesión" onClick={handleLogout} sx={buttonSx(false)}>
            <LogoutIcon sx={iconSx(false)} />
          </IconButton>
        </Stack>
      </Stack>
    </Box>
  );
}
